import {
    CalculationDegradationNames, CalculationInput, CalculationModelNames,
    CalculationModelType, CommentCategory, CommentCategoryHeaderText,
    Degradation, PointResult, RiskCalculationDetailView
} from 'src/app/contracts';

export class CsvDataHelper {
    public static createData(
        calculation: RiskCalculationDetailView,
        calculationInput: CalculationInput,
        degradationCompoundIndices: Array<number>,
        plotPointResult: PointResult,
        plotPointDist: number
    ): any {
        const fieldDefs = [];
        const data: any = {};
        let ret = '\uFEFF'; // This is for BOM
        fieldDefs.push({
            label: 'Lokalitet',
            value: 'location'
        });
        data.location = calculation.location.number + ' - ' + calculation.location.name;
        ret += 'Lokalitet;'
            + calculation.location.number + ' - ' + calculation.location.name + '\n';

        fieldDefs.push({
            label: 'Forureningsstof',
            value: 'contaminantName'
        });
        data.contaminantName = calculation.calculationInput.contaminantName;
        ret += 'Forureningsstof;'
            + calculation.calculationInput.contaminantName + '\n';

        fieldDefs.push({
            label: 'Beregningsmodel',
            value: 'calculationModelType'
        });
        data.calculationModelType = CalculationModelNames[calculation.calculationInput.modelType];
        ret += 'Beregningsmodel;'
            + CalculationModelNames[calculation.calculationInput.modelType] + '\n';

        // Parameters
        // - Kildekoncentration
        fieldDefs.push({
            label: 'Nedbrydning',
            value: 'calculationDegradation'
        });
        data.calculationDegradation = CalculationDegradationNames[calculation.calculationInput.degradation];
        ret += 'Nedbrydning;'
            + CalculationDegradationNames[calculation.calculationInput.degradation] + '\n';

        // tslint:disable-next-line: no-shadowed-variable
        for (let i = 0; i < calculationInput.degradationChainCompoundNames.length; i++) {
            // tslint:disable-next-line: no-shadowed-variable
            const name = calculationInput.degradationChainCompoundNames[i];
            if (!name) {
                continue;
            }
            if (i >= calculationInput.sourceConcentration.length) {
                break;
            }
            fieldDefs.push({
                label: name,
                value: 'inputSourceConcentration' + i
            });
            data['inputSourceConcentration' + i] = calculationInput.sourceConcentration[i] + ' µg/L';
            ret += name + ';'
                + calculationInput.sourceConcentration[i].toLocaleString('da-DK') + ' µg/L' + '\n';
        }

        if (calculationInput.modelType !== CalculationModelType.ModelIV) {
            fieldDefs.push({
                label: 'Længde af kilde',
                value: 'inputSourceLength'
            });
            data.inputSourceLength = calculationInput.sourceLength + ' m';
            ret += 'Længde af kilde;'
                + calculationInput.sourceLength.toLocaleString('da-DK') + ' m' + '\n';
        }

        if (calculationInput.modelType !== CalculationModelType.ModelIV) {
            fieldDefs.push({ label: 'Bredde af kilde', value: 'inputSourceWidth' });
            data.inputSourceWidth = calculationInput.sourceWidth + ' m';
            ret += 'Bredde af kilde;' + calculationInput.sourceWidth.toLocaleString('da-DK') + ' m' + '\n';
        }

        if (calculationInput.modelType !== CalculationModelType.ModelIV) {
            fieldDefs.push({
                label: 'Infiltration i kildeområde',
                value: 'inputSourceInfiltration'
            });
            data.inputSourceInfiltration = calculationInput.sourceInfiltration + ' mm/år';
            ret += 'Infiltration i kildeområde;'
                + calculationInput.sourceInfiltration.toLocaleString('da-DK') + ' mm/år' + '\n';
        }

        if (calculationInput.modelType === CalculationModelType.ModelIV) {
            fieldDefs.push({
                label: 'Radius af kildeområde',
                value: 'inputSourceRadius'
            });
            data.inputSourceRadius = calculationInput.sourceRadius + ' m';
            ret += 'Radius af kildeområde;'
                + calculationInput.sourceRadius.toLocaleString('da-DK') + ' m' + '\n';
        }

        if (calculationInput.modelType === CalculationModelType.ModelIV
            && calculationInput.degradation === Degradation.None) {
            fieldDefs.push({
                label: 'Grænseradius, hvor koncentrationen antages lig nul',
                value: 'inputConcentrationZeroRadius'
            });
            data.inputConcentrationZeroRadius = calculationInput.concentrationZeroRadius + ' m';
            ret += 'Grænseradius, hvor koncentrationen antages lig nul;'
                + calculationInput.concentrationZeroRadius.toLocaleString('da-DK') + ' m' + '\n';
        }

        fieldDefs.push({ label: 'Infiltration over fanen', value: 'inputPlumeInfiltration' });
        data.inputPlumeInfiltration = calculationInput.plumeInfiltration + ' mm/år';
        ret += 'Infiltration over fanen;'
            + calculationInput.plumeInfiltration.toLocaleString('da-DK') + ' mm/år' + '\n';

        // - Vertikal transport
        if (calculationInput.modelType !== CalculationModelType.ModelV) {
            if (calculationInput.modelType !== CalculationModelType.ModelIV) {
                fieldDefs.push({ label: 'Afstand fra kilde til top af grundvandsmagasin', value: 'inputSourceToAquiferDist' });
                data.inputSourceToAquiferDist = calculationInput.sourceToAquiferDist + ' m';
                ret += 'Afstand fra kilde til top af grundvandsmagasin;'
                    + calculationInput.sourceToAquiferDist.toLocaleString('da-DK') + ' m' + '\n';
            }

            if (calculationInput.modelType === CalculationModelType.ModelIV) {
                fieldDefs.push({
                    label: 'Kapillarzonens dybde',
                    value: 'inputCapillaryFringe'
                });
                data.inputCapillaryFringe = calculationInput.capillaryFringe + ' m';
                ret += 'Kapillarzonens dybde;'
                    + calculationInput.capillaryFringe.toLocaleString('da-DK') + ' m' + '\n';
            }

            fieldDefs.push({ label: 'Porøsitet', value: 'inputVerticalPorosity' });
            data.inputVerticalPorosity = calculationInput.verticalPorosity;
            ret += 'Porøsitet;'
                + calculationInput.verticalPorosity.toLocaleString('da-DK') + '\n';

            if (calculationInput.modelType === CalculationModelType.ModelIII
                || calculationInput.modelType === CalculationModelType.ModelIV) {
                fieldDefs.push({
                    label: 'Vandindhold',
                    value: 'inputWaterContent'
                });
                data.inputWaterContent = calculationInput.waterContent;
                ret += 'Vandindhold;'
                    + calculationInput.waterContent.toLocaleString('da-DK') + '\n';
            }

            if (calculationInput.modelType !== CalculationModelType.ModelIV) {
                fieldDefs.push({
                    label: 'Longitudinal dispersivitet (z-retning)',
                    value: 'inputVerticalLongitudinalDispersivity'
                });
                data.inputVerticalLongitudinalDispersivity = calculationInput.verticalLongitudinalDispersivity + ' m';
                ret += 'Longitudinal dispersivitet (z-retning);'
                    + calculationInput.verticalLongitudinalDispersivity.toLocaleString('da-DK') + ' m' + '\n';
            }

            if (calculationInput.modelType === CalculationModelType.ModelIII) {
                fieldDefs.push({
                    label: 'Transversal dispersivitet (y-retning)',
                    value: 'inputVerticalTransversalDispersivity'
                });
                data.inputVerticalTransversalDispersivity = calculationInput.verticalTransversalDispersivity + ' m';
                ret += 'Transversal dispersivitet (y-retning);'
                    + calculationInput.verticalTransversalDispersivity + ' m' + '\n';
            }

            // 1. ordens nedbrydningsrate
            if (calculationInput.modelType === CalculationModelType.ModelI
                || calculationInput.modelType === CalculationModelType.ModelII) {
                // tslint:disable-next-line: no-shadowed-variable
                for (let i = 0; i < degradationCompoundIndices.length
                    && i < calculationInput.degradationChainCompoundNames.length; i++) {
                    // tslint:disable-next-line: no-shadowed-variable
                    const name = calculationInput.degradationChainCompoundNames[i];
                    if (!name) {
                        continue;
                    }
                    if (i >= calculationInput.verticalFirstOrderDegradationRate.length) {
                        break;
                    }
                    fieldDefs.push({
                        label: '1. ordens nedbrydningsrate, ' + name,
                        value: 'inputVerticalFirstOrderDegradationRate' + i
                    });
                    data['inputVerticalFirstOrderDegradationRate' + i] =
                        calculationInput.verticalFirstOrderDegradationRate[i] + ' d-1';
                    ret += '1. ordens nedbrydningsrate' + name + ';'
                        + calculationInput.verticalFirstOrderDegradationRate[i].toLocaleString('da-DK')
                        + ' d-1' + '\n';
                }
            }

            // 1. ordens nedbrydningsrate, {{calculationInput.contaminantName}}
            if (calculationInput.modelType === CalculationModelType.ModelIII
                || calculationInput.modelType === CalculationModelType.ModelIV) {
                fieldDefs.push({
                    label: '1. ordens nedbrydningsrate, ' + calculationInput.contaminantName,
                    value: 'inputVerticalFirstOrderDegradationRate_contaminantName'
                });
                data.inputVerticalFirstOrderDegradationRate_contaminantName
                    = calculationInput.verticalFirstOrderDegradationRate[0] + ' d-1';
                ret += '1. ordens nedbrydningsrate' + calculationInput.contaminantName + ';'
                    + calculationInput.verticalFirstOrderDegradationRate[0].toLocaleString('da-DK')
                    + ' d-1' + '\n';
            }

            if (calculationInput.modelType === CalculationModelType.ModelII) {
                fieldDefs.push({
                    label: 'Sprækkeafstand',
                    value: 'inputFractureSpacing'
                });
                data.inputFractureSpacing = calculationInput.fractureSpacing + ' m';
                ret += 'Sprækkeafstand;'
                    + calculationInput.fractureSpacing.toLocaleString('da-DK') + ' m' + '\n';
            }

            if (calculationInput.modelType === CalculationModelType.ModelII) {
                fieldDefs.push({
                    label: 'Sprækkeafstand',
                    value: 'inputFractureAperture'
                });
                data.inputFractureAperture = calculationInput.fractureAperture + ' m';
                ret += 'Sprækkeafstand;'
                    + calculationInput.fractureAperture.toLocaleString('da-DK') + ' m' + '\n';
            }

            if (calculationInput.modelType === CalculationModelType.ModelII) {
                fieldDefs.push({
                    label: 'Bulk hydraulisk konduktivitet',
                    value: 'inputBulkHydraulicConductivity'
                });
                data.inputBulkHydraulicConductivity = calculationInput.bulkHydraulicConductivity + ' m';
                ret += 'Bulk hydraulisk konduktivitet;'
                    + calculationInput.bulkHydraulicConductivity.toLocaleString('da-DK') + ' m' + '\n';
            }
        }

        // Horisontal transport
        fieldDefs.push({
            label: 'Mægtighed af grundvandsmagasinet (fra top til bund)',
            value: 'inputAquiferThickness'
        });
        data.inputAquiferThickness = calculationInput.aquiferThickness + ' m';
        ret += 'Mægtighed af grundvandsmagasinet (fra top til bund);'
            + calculationInput.aquiferThickness.toLocaleString('da-DK') + ' m' + '\n';

        fieldDefs.push({
            label: 'Grundvandshastighed',
            value: 'inputGroundwaterVelocity'
        });
        data.inputGroundwaterVelocity = calculationInput.groundwaterVelocity + ' m/år';
        ret += 'Grundvandshastighed;' + calculationInput.groundwaterVelocity.toLocaleString('da-DK') + ' m/år' + '\n';

        if (calculationInput.calculateGroundwaterVelocity) {
            fieldDefs.push({
                label: 'Hydraulisk konduktivitet',
                value: 'inputHydraulicConductivity'
            });
            data.inputHydraulicConductivity = calculationInput.hydraulicConductivity + ' m/s';
            ret += 'Hydraulisk konduktivitet;'
                + calculationInput.hydraulicConductivity.toLocaleString('da-DK') + ' m/s' + '\n';

            fieldDefs.push({
                label: 'Hydraulisk gradient',
                value: 'inputHydraulicGradient'
            });
            data.inputHydraulicGradient = calculationInput.hydraulicGradient;
            ret += 'Hydraulisk gradient;'
                + calculationInput.hydraulicGradient.toLocaleString('da-DK') + '\n';
        }

        fieldDefs.push({ label: 'Porøsitet', value: 'inputHorizontalPorosity' });
        data.inputHorizontalPorosity = calculationInput.horizontalPorosity;
        ret += 'Porøsitet;'
            + calculationInput.horizontalPorosity.toLocaleString('da-DK') + '\n';

        // tslint:disable-next-line: no-shadowed-variable
        for (let i = 0; i < degradationCompoundIndices.length
            && i < calculationInput.degradationChainCompoundNames.length; i++) {
            // tslint:disable-next-line: no-shadowed-variable
            const name = calculationInput.degradationChainCompoundNames[i];
            if (!name) {
                continue;
            }
            if (i >= calculationInput.horizontalFirstOrderDegradationRate.length) {
                break;
            }
            fieldDefs.push({
                label: '1. ordens nedbrydningsrate, ' + name,
                value: 'inputHorizontalFirstOrderDegradationRate' + i
            });
            data['inputHorizontalFirstOrderDegradationRate' + i] = calculationInput.horizontalFirstOrderDegradationRate[i] + ' d-1';
            ret += '1. ordens nedbrydningsrate' + name + ';'
                + calculationInput.horizontalFirstOrderDegradationRate[i].toLocaleString('da-DK') + ' d-1' + '\n';
        }

        fieldDefs.push({
            label: 'Longitudinal dispersivitet (x-retning)',
            value: 'inputHorizontalLongitudinalDispersivity'
        });
        data.inputHorizontalLongitudinalDispersivity = calculationInput.horizontalLongitudinalDispersivity + ' m';
        ret += 'Longitudinal dispersivitet (x-retning);'
            + calculationInput.horizontalLongitudinalDispersivity.toLocaleString('da-DK') + ' m' + '\n';

        fieldDefs.push({
            label: 'Transversal dispersivitet (y-retning)',
            value: 'inputHorizontalTransversalDispersivity'
        });
        data.inputHorizontalTransversalDispersivity = calculationInput.horizontalTransversalDispersivity + ' m';
        ret += 'Transversal dispersivitet (y-retning);'
            + calculationInput.horizontalTransversalDispersivity.toLocaleString('da-DK') + ' m' + '\n';

        fieldDefs.push({
            label: 'Vertikal dispersivitet (z-retning)',
            value: 'inputHorizontalVerticalDispersivity'
        });
        data.inputHorizontalVerticalDispersivity = calculationInput.horizontalVerticalDispersivity + ' m';
        ret += 'Vertikal dispersivitet (z-retning);'
            + calculationInput.horizontalVerticalDispersivity.toLocaleString('da-DK') + ' m' + '\n';

        if (calculationInput.hasAdditionalPoC) {
            fieldDefs.push({
                label: 'Afstand fra kilde til nedstrøms kontrolpunkt',
                value: 'inputAdditionalPoCDistanceFromSource'
            });
            data.inputAdditionalPoCDistanceFromSource = calculationInput.additionalPoCDistanceFromSource + ' m';
            ret += 'Afstand fra kilde til nedstrøms kontrolpunkt;'
                + calculationInput.additionalPoCDistanceFromSource.toLocaleString('da-DK') + ' m' + '\n';

            fieldDefs.push({
                label: 'Filterlængde som koncentrationen i kontrolpunktet midles over',
                value: 'inputAdditionalPoCScreenLength'
            });
            data.inputAdditionalPoCScreenLength = calculationInput.additionalPoCScreenLength + ' m';
            ret += 'Filterlængde som koncentrationen i kontrolpunktet midles over;'
                + calculationInput.additionalPoCScreenLength.toLocaleString('da-DK') + ' m' + '\n';
        }

        fieldDefs.push({
            label: 'Indvindingsrate ved nærmeste indvinding',
            value: 'inputAbstractionRate'
        });
        data.inputAbstractionRate = calculationInput.abstractionRate + ' m3/år';
        ret += 'Indvindingsrate ved nærmeste indvinding;'
            + calculationInput.abstractionRate.toLocaleString('da-DK') + ' m3/år' + '\n';

        // Charts
        if (plotPointResult.horizontalPlumeConcentration) {
            // tslint:disable-next-line: no-shadowed-variable
            for (let i = 0; i < plotPointResult.horizontalPlumeConcentration.length; i++) {
                // tslint:disable-next-line: no-shadowed-variable
                const name = CsvDataHelper.shortCompoundNameFromDegradationChain(calculationInput, i);
                if (!name) {
                    continue;
                }
                // tslint:disable-next-line: no-shadowed-variable
                const label = 'Koncentration langs fanen';
                fieldDefs.push({
                    label: label + ' - Afstand langs fanen(m) - ' + name,
                    value: 'chartXHorizontalPlumeConcentration' + i
                });
                ret += 'Koncentration langs fanen - Afstand langs fanen(m) - ' + name + ';';

                // tslint:disable-next-line: no-shadowed-variable
                let X = [];
                if (plotPointResult.horizontalPlumeConcentration[i].x) {
                    X = X.concat(plotPointResult.horizontalPlumeConcentration[i].x);
                }
                data['chartXHorizontalPlumeConcentration' + i] = X.join(',');
                ret += X.map(xx => (xx as number).toLocaleString('da-DK', { minimumFractionDigits: 2 }))
                    .join(';') + '\n';

                fieldDefs.push({
                    label: label + ' - Koncentration(µg/l) - ' + name,
                    value: 'chartYHorizontalPlumeConcentration' + i
                });
                ret += 'Koncentration langs fanen - Koncentration(µg/l) - ' + name + ';';

                // tslint:disable-next-line: no-shadowed-variable
                let Y = [];
                if (plotPointResult.horizontalPlumeConcentration[i].y) {
                    Y = Y.concat(plotPointResult.horizontalPlumeConcentration[i].y);
                }
                data['chartYHorizontalPlumeConcentration' + i] = Y.join(',');
                ret += Y.map(yy => (yy as number).toLocaleString('da-DK', { minimumFractionDigits: 2 }))
                    .join(';') + '\n';
            }
        }

        if (plotPointResult.plumeConcentrationAtPoC) {
            // tslint:disable-next-line: no-shadowed-variable
            for (let i = 0; i < plotPointResult.plumeConcentrationAtPoC.length; i++) {
                // tslint:disable-next-line: no-shadowed-variable
                const name = CsvDataHelper.shortCompoundNameFromDegradationChain(calculationInput, i);
                if (!name) {
                    continue;
                }
                // tslint:disable-next-line: no-shadowed-variable
                const label = 'Koncentrationen over dybden i kontrolpunktet '
                    + plotPointDist + ' m nedstrøms';
                fieldDefs.push({
                    label: label + ' - Dybde under grundvandsspejlet (m) - '
                        + name, value: 'chartXPlumeConcentrationAtPoC' + i
                });
                ret += label + ' - Dybde under grundvandsspejlet (m) - ' + name + ';';

                // tslint:disable-next-line: no-shadowed-variable
                let Y = [];
                if (plotPointResult.plumeConcentrationAtPoC[i].y) {
                    Y = Y.concat(plotPointResult.plumeConcentrationAtPoC[i].y);
                }
                data['chartXPlumeConcentrationAtPoC' + i] = Y.join(',');
                ret += Y.map(yy => (yy as number).toLocaleString('da-DK', { minimumFractionDigits: 2 }))
                    .join(';') + '\n';

                fieldDefs.push({
                    label: label + ' - Koncentration (µg/L) - ' + name,
                    value: 'chartYPlumeConcentrationAtPoC' + i
                });
                ret += label + ' - Koncentration (µg/L) - ' + name + ';';

                // tslint:disable-next-line: no-shadowed-variable
                let X = [];
                if (plotPointResult.plumeConcentrationAtPoC[i].x) {
                    X = X.concat(plotPointResult.plumeConcentrationAtPoC[i].x);
                }
                data['chartYPlumeConcentrationAtPoC' + i] = X.join(',');
                ret += X.map(xx => (xx as number).toLocaleString('da-DK', { minimumFractionDigits: 2 }))
                    .join(';') + '\n';
            }
        }

        if (plotPointResult.verticalModelOutput) {
            // tslint:disable-next-line: no-shadowed-variable
            for (let i = 0; i < plotPointResult.verticalModelOutput.length; i++) {
                // tslint:disable-next-line: no-shadowed-variable
                const name = CsvDataHelper.shortCompoundNameFromDegradationChain(calculationInput, i);
                if (!name) {
                    continue;
                }
                // tslint:disable-next-line: no-shadowed-variable
                const label = 'Koncentration over grundvandsspejlet';
                fieldDefs.push({
                    label: label + ' - Koncentration (µg/L) - ' + name,
                    value: 'chartXVerticalModelOutput' + i
                });
                ret += label + ' - Koncentration (µg/L) - ' + name + ';';

                // tslint:disable-next-line: no-shadowed-variable
                let X = [];
                if (plotPointResult.verticalModelOutput[i].x) {
                    X = X.concat(plotPointResult.verticalModelOutput[i].x);
                }
                data['chartXVerticalModelOutput' + i] = X.join(',');
                ret += X.map(xx => (xx as number).toLocaleString('da-DK', { minimumFractionDigits: 2 }))
                    .join(';') + '\n';

                fieldDefs.push({
                    label: label + ' - Dybde under kilden (m) - ' + name,
                    value: 'chartYVerticalModelOutput' + i
                });
                ret += label + ' - Dybde under kilden (m) - ' + name + ';';

                // tslint:disable-next-line: no-shadowed-variable
                let Y = [];
                if (plotPointResult.verticalModelOutput[i].y) {
                    Y = Y.concat(plotPointResult.verticalModelOutput[i].y);
                }
                data['chartYVerticalModelOutput' + i] = Y.join(',');
                ret += Y.map(yy => (yy as number).toLocaleString('da-DK', { minimumFractionDigits: 2 }))
                    .join(';') + '\n';
            }
        }

        if (plotPointResult.aquiferTopConcentration) {
            for (let i = 0; i < plotPointResult.aquiferTopConcentration.length; i++) {
                const name = CsvDataHelper.shortCompoundNameFromDegradationChain(calculationInput, i);
                if (!name) {
                    continue;
                }
                const label = 'Koncentrationen ved toppen af grundvandet';
                fieldDefs.push({ label: label + ' - Dybde under kilden (m) - ' + name, value: 'chartXAquiferTopConcentration' + i });
                ret += label + ' - Dybde under kilden (m) - ' + name + ';';

                let X = [];
                if (plotPointResult.aquiferTopConcentration[i].x) {
                    X = X.concat(plotPointResult.aquiferTopConcentration[i].x);
                }
                data['chartXAquiferTopConcentration' + i] = X.join(',');
                ret += X.map(xx => (xx as number).toLocaleString('da-DK', { minimumFractionDigits: 2 }))
                    .join(';') + '\n';

                fieldDefs.push({
                    label: label + ' - Koncentration (µg/L) - ' + name,
                    value: 'chartYAquiferTopConcentration' + i
                });
                ret += label + ' - Koncentration (µg/L) - ' + name + ';';
                let Y = [];
                if (plotPointResult.aquiferTopConcentration[i].y) {
                    Y = Y.concat(plotPointResult.aquiferTopConcentration[i].y);
                }
                data['chartYAquiferTopConcentration' + i] = Y.join(',');
                ret += Y.map(yy => (yy as number).toLocaleString('da-DK', { minimumFractionDigits: 2 }))
                    .join(';') + '\n';
            }
        }

        // Comments
        for (const comment of calculation.comments) {
            let label = 'Note';
            if (comment.category !== CommentCategory.None) {
                label = CommentCategoryHeaderText.get(comment.category);
            }
            fieldDefs.push({
                label,
                value: 'comment' + comment.category
            });
            data['comment' + comment.category] = comment.text;
            ret += label + ';'
                + comment.text + '\n';
        }

        return {
            fieldDefs,
            data,
            ret
        };
    }

    public static shortCompoundNameFromDegradationChain(
        calculationInput: CalculationInput, index: number): string {
        return (calculationInput.degradationChainCompoundNames[index].length > 10)
            ? (calculationInput.degradationChainCompoundNames[index].substring(0, 8) + '...')
            : calculationInput.degradationChainCompoundNames[index];
    }
}
